import React from "react";

/** Loading placeholder (§3.14): never blank white, never layout shift. */
export function Skeleton({ width = "100%", height = 16, radius, style }) {
  return (
    <span
      className="fk-skeleton"
      style={{ width, height, borderRadius: radius, ...style }}
      aria-hidden="true"
    />
  );
}

/** A stack of text-line skeletons. */
export function SkeletonText({ lines = 3 }) {
  return (
    <span style={{ display: "block" }}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          height={12}
          width={i === lines - 1 ? "60%" : "100%"}
          style={{ marginBottom: 8 }}
        />
      ))}
    </span>
  );
}
